import { pm } from '@renderer/modules/api/pm';
import type { ApiResponse, OpenOrder, Order } from '@renderer/modules/types';

export async function placeOrder(order: Order): Promise<ApiResponse<{ notional?: number; orderID?: string; orderId?: string }>> {
  return pm.placeOrder(order);
}

export async function listOpenOrders(filters?: { asset_ids?: string[] }): Promise<ApiResponse<OpenOrder[]>> {
  return pm.listOpenOrders(filters);
}

export async function cancelOrder(orderId: string): Promise<ApiResponse> {
  return pm.cancelOrder(orderId);
}

export async function cancelAll(scope?: { asset_id?: string }): Promise<ApiResponse<{ cancelled?: number }>> {
  return pm.cancelAll(scope);
}


